/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable no-mixed-operators */
import React from "react";
import { withStyles } from "@material-ui/core/styles";
import newWindowIcon from "../assets/newWindowIcon.svg"
import { removeXSSAttacks } from "../common/helper";
import { getScrollbarWidth } from "../common/helper";
import HistoryStyle from "../styles/historyStyle";


class History extends React.Component {
    state = { selectedRow: void 0 }
    componentDidMount() {
        let { GetHistory, productInfo = {} } = this.props;
        GetHistory && GetHistory(productInfo);
    }
    UNSAFE_componentWillUnmount() {
        let { ResetHistoryTab } = this.props;
        ResetHistoryTab && ResetHistoryTab()
    }

    componentDidUpdate(prevProps) {
        let { historyData = [] } = this.props;
        let { historyData: prevHistoryData = [] } = prevProps;
        if (prevHistoryData.length !== historyData.length) {
            this.onHistoryScroll()
        }
    }


    pop = (url, w, h) => {
        let n = window.open(url, '_blank', 'toolbar=0,location=0,directories=0,status=1,menubar=0,titlebar=0,scrollbars=1,resizable=1,width=' + w + ',height=' + h);
        if (n == null) {
            return true;
        }
        return false;
    }

    getHistory = (data = []) => {
        let { classes, selectedPatientInfo } = this.props;
        if (!data.length) {
            return (
                <div id="history-empty-row" className={classes.emptyRow}>
                    No historical orders for this patient.
                </div>
            )
        } else {
            return (
                data ? data.map((value, index) => {
                    return (
                        <div className={`${classes.historyRowWrapper} ${index % 2 === 0 ? classes.historyOddRowWrapper : ""}`}>
                            <div id="history-date-row" className={classes.dateRowStyle}>{value.OrderDate}</div>
                            <div id="history-order-number-row" title={value.OrderId} className={classes.orderNumber}>
                                <span id="history-order-id-row" className={classes.ellipsis}>{value.OrderId}</span>
                                <a id="history-new-window-row" title={"See this order's details in a new browser window"} className={classes.newWindowIcon} target="_blank" onClick={_ => this.pop(`/history/${value.OrderId}/${selectedPatientInfo.UserId}`, 1290, 780)} >
                                    <img alt="" className={classes.newWindowIcon} src={newWindowIcon} />
                                </a>
                            </div>
                            <div className={classes.historyProductContainer}>
                                {
                                    value.Products ? value.Products.map((_value, index) => {
                                        return (
                                            <div id="history-product-row" className={classes.historyProductWrapper}>
                                                <div id="history-product-title-row" title={_value.displayTitle} className={classes.productsRowStyle}><span className={classes.ellipsis}>{_value.displayTitle}</span></div>
                                                <div id="history-order-type-row" title={_value.OrderType} className={classes.orderTypeRowStyle}><span className={classes.ellipsis}>{_value.OrderType}</span></div>
                                                <div id="history-approval-status-row" title={_value.ApprovalStatus} className={classes.approvalRowStyle}><span className={classes.ellipsis} dangerouslySetInnerHTML={{ __html: removeXSSAttacks(_value.ApprovalStatus) }}></span></div>
                                            </div>
                                        )
                                    }) : null
                                }
                            </div>
                            <div title={value.OrderStatus} id="history-order-status-row" className={classes.orderStatusRowStyle}><span className={classes.ellipsis}>{value.OrderStatus}</span></div>
                        </div>
                    )
                }) : null
            )
        }
    }

    onHistoryScroll = () => {
        const scrollWrapper = document && document.getElementsByClassName("scrollContainer")[0] || {};
        const fixedHeadersDiv = document && document.getElementsByClassName("fixedHistoryTitle")[0] || {};
        if (scrollWrapper.clientHeight < scrollWrapper.scrollHeight) {
            fixedHeadersDiv.style.paddingRight = getScrollbarWidth() + "px";
        }
    }

    render() {
        let { classes, loading, historyData = [] } = this.props;
        return (
            <div data-app="history-component-wrapper" className={classes.fixHistoryHeaderWrapper}>
                <div className={`${classes.tableHeader} fixedHistoryTitle`}>
                    <div id="history-date-header" className={classes.dateSection}>
                        Date
                        </div>
                    <div id="history-order-number-header" className={classes.orderSection}>
                        Order Number
                        </div>
                    <div id="history-products-header" className={classes.products}>
                        Product(s)
                        </div>
                    <div id="history-order-type-header" className={classes.orderType}>
                        Order Type
                    </div>
                    <div id="history-approval-header" className={classes.approval}>
                        Approval
                    </div>
                    <div id="history-order-status-header" className={classes.orderStatus}>
                        Order Status
                    </div>
                </div>
                <div id="history-scroll-window" onScroll={this.onHistoryScroll} className={`${classes.emailWrapper} scrollContainer`}>
                    {loading ? null : this.getHistory(historyData)}
                </div>
            </div>
        )
    }
}


export default withStyles(HistoryStyle)(History);

